import { motion } from "framer-motion";
import { Award, Radio } from "lucide-react";
import { LABELS, RADIO_RESIDENCY } from "@/lib/constants";
import { easeOutExpo } from "@/lib/motion";

// Compact luxury credibility bar for the Hero.
export const CredibilityBar = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 1.85, ease: easeOutExpo }}
      data-testid="hero-credibility-bar"
      className="mt-12 flex flex-col gap-5 md:gap-4 max-w-2xl"
    >
      {/* Official Releases row */}
      <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-5">
        <div className="flex items-center gap-2">
          <Award size={12} className="text-gold" />
          <span className="text-[10px] font-bold uppercase tracking-[0.32em] text-gold whitespace-nowrap">
            Official Releases
          </span>
        </div>
        <div className="hidden md:block h-3 w-px bg-[color:var(--line-strong)]" />
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-ink/85">
          {LABELS.map((l, i) => (
            <span key={l.name} className="inline-flex items-center gap-3">
              {l.name}
              {i < LABELS.length - 1 && (
                <span className="text-[color:var(--gold-hi)]/60">✦</span>
              )}
            </span>
          ))}
        </div>
      </div>

      {/* Resident Artist row */}
      <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-5">
        <div className="flex items-center gap-2">
          <Radio size={12} className="text-gold" />
          <span className="text-[10px] font-bold uppercase tracking-[0.32em] text-gold whitespace-nowrap">
            Resident Artist
          </span>
        </div>
        <div className="hidden md:block h-3 w-px bg-[color:var(--line-strong)]" />
        <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-ink/85">
          {RADIO_RESIDENCY.name}
        </span>
      </div>
    </motion.div>
  );
};
